import { render } from "./Resellers.vue?vue&type=template&id=f6376358&scoped=true"
import script from "./Resellers.vue?vue&type=script&lang=js"
export * from "./Resellers.vue?vue&type=script&lang=js"

import "./Resellers.vue?vue&type=style&index=0&id=f6376358&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6376358"]])

export default __exports__